import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function UsersCheckIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="m10.4 11.667 1.2 1.222 2.4-2.445m-6-.61H5.6c-1.118 0-1.677 0-2.118.185a2.42 2.42 0 0 0-1.3 1.323C2 11.792 2 12.361 2 13.5m8.1-10.822c.88.362 1.5 1.24 1.5 2.266s-.62 1.905-1.5 2.267M8.9 4.944c0 1.35-1.075 2.445-2.4 2.445S4.1 6.294 4.1 4.944 5.175 2.5 6.5 2.5s2.4 1.094 2.4 2.444" /></svg>
  );
}

export default UsersCheckIcon;
